import type { FaireReviewEntity } from "../../entity_types/review";

export const review_r8: FaireReviewEntity = {
  token: "review_r8",
  type: "review",
  brandName: "ROEN",
  reviewerName: "Michele",
  reviewerLocation: "Granby, QC, Canada",
  stars: 5,
  reviewText: "Parfait",
  reviewDate: "Nov 13, 2024",
  reviewType: "brand",
  brandResponse:
    "Bonjour Michele! We are delighted you let us know you are enjoying the products. Your support from across the border means the world to us — merci beaucoup!",
  isTranslated: true,
  purchasedProductImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/a15d1fc087908754991b018a69774258782ff3fad6f50ef4078fe96c26a1caf6.webp",
    "https://cdn.prerelease.faire.dev/fastly/59a4005712dbc289690cccb048ed1838bfbb32630127b5ae4ce805f9204e0b93.webp",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
